/* eslint-disable lingui/no-unlocalized-strings -- DEV-only test fixture, no user-facing copy */
// Regression fixture for CC-21: a Kobalte Select inside our modal Dialog.
// NOT a product screen — registered ONLY in DEV (see router.ts) so the e2e
// `cc21-probe.spec` can assert the dropdown options stay reachable (not
// aria-hidden by the Dialog's ariaHideOutside). Guards the overlay-portal fix.
import { createRoute } from "@tanstack/solid-router";
import { createSignal } from "solid-js";

import { appRoute } from "./route";
import { Dialog, DialogTitle } from "@/components/ui/dialog";
import { Select } from "@/components/ui/select";
import { Button } from "@/components/ui/button";

function Cc21ProbePage() {
  const [open, setOpen] = createSignal(true);
  const [value, setValue] = createSignal("");
  return (
    <div class="p-8">
      <Button data-testid="cc21-open" onClick={() => setOpen(true)}>
        Open
      </Button>
      <span data-testid="cc21-value">{value()}</span>
      <Dialog open={open()} onOpenChange={setOpen} contentClass="max-w-[420px] p-6">
        <DialogTitle class="text-xl font-bold mb-4">CC21 probe</DialogTitle>
        <Select
          aria-label="Probe select"
          placeholder="Pick one"
          value={value()}
          onChange={(v) => setValue(v)}
          options={[
            { value: "alpha", label: "Alpha" },
            { value: "beta", label: "Beta" },
            { value: "gamma", label: "Gamma" },
          ]}
        />
      </Dialog>
    </div>
  );
}

export const cc21ProbeRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/cc21-probe",
  component: Cc21ProbePage,
});
